
import Vue, { PropType } from 'vue'
import { Sensor, SensorStatus } from '@/models'
import moment from 'moment'

function convertSensorStatus(rawSensorStatus?: SensorStatus): string {
  switch (rawSensorStatus) {
    case SensorStatus.UNINITIALIZED:
      return '未初期化'
    case SensorStatus.RUNNING:
      return '稼動'
    case SensorStatus.SUSPENDED:
      return '停止'
    default:
      return '不明'
  }
}

export default Vue.extend({
  name: 'SensorListItem',

  props: {
    sensor: Object as PropType<Sensor>
  },

  computed: {
    isAdmin(): boolean {
      return this.$auth.role === "admin"
    },

    battery(): number | undefined {
      return this.sensor?.details?.battery
    },

    typeText(): string {
      const type = this.sensor?.sensorType
      if (type === 'door-v1') return 'ドアセンサ-V1'
      if (type === 'door-v2') return 'ドアセンサ-V2'
      if (type === 'door-r1') return 'ドアセンサ-R1'
      if (type === 'infrared-v1') return '人感センサ-V1'
      if (type === 'infrared-r1') return '人感センサ-R1'
      if (type === 'distance') return '距離センサ'
      if (type === 'mic') return '新 MIC'
      if (type === 'thermopile') return 'サーモセンサー'
      return '不明'
    },

    batteryText(): string {
      const battery = this.sensor?.details?.battery
      if (!battery) {
        return ''
      }
      if (battery < 20) {
        return 'Low'
      }
      if (battery < 40) {
        return 'Low'
      }
      if (battery < 75) {
        return 'Mid'
      }
      return 'High'
    },

    batteryTextClass(): string {
      const battery = this.sensor?.details?.battery
      if (!battery) {
        return ''
      }
      if (battery < 20) {
        return 'battery-red'
      }
      if (battery < 40) {
        return 'battery-orange'
      }
      return 'battery-green'
    },

    statusText(): string {
      return convertSensorStatus(this.sensor?.details?.status)
    },

    statusTextClass(): string {
      return [
        SensorStatus.UNKNOWNSENSORSTATUS,
        SensorStatus.UNINITIALIZED,
        SensorStatus.SUSPENDED,
      ].includes(this.sensor?.details?.status || SensorStatus.UNKNOWNSENSORSTATUS) ? 'red' : ''
    },

    checkedTimeText(): string {
      if (!this.sensor?.details?.latestDateTime) return 'なし'
      return moment(this.sensor?.details?.latestDateTime).format('YYYY-MM-DD(HH:mm:ss)')
    },

    deletable(): boolean {
      return this.sensor?.details?.status !== SensorStatus.RUNNING
    },

    deleteButtonClassText(): string {
      return this.deletable ? 'hover-circle' : 'disabled'
    }
  },

  methods: {
    showDeleteScreen(): void {
      if (!this.deletable) {
        return
      }
      const companyId = this.$auth.companyId
      const sensorId = this.sensor.id
      if (!companyId || !sensorId) {
        return
      }
      this.$router.push({
        name: 'admin-company-sensor-delete',
        params: {
          companyId: companyId,
          sensorId: sensorId
        }
      })
    }
  }
})
